import ChipStatement from "./ChipStatement";

export default ChipStatement;